/**
 * How often an open calendar re-reads the events of the displayed interval, in milliseconds.
 * Appointments are not part of the local database sync, they only exist on the server, so bookings
 * made outside of this device (online booking, another POS, the admin page) can only be picked up
 * by asking for them again.
 */
export const CALENDAR_REFRESH_INTERVAL = 60000;
